import { render, staticRenderFns } from "./TaxTable.vue?vue&type=template&id=03d27bf3&scoped=true"
import script from "./TaxTable.vue?vue&type=script&lang=js"
export * from "./TaxTable.vue?vue&type=script&lang=js"
import style0 from "./TaxTable.vue?vue&type=style&index=0&id=03d27bf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d27bf3",
  null
  
)

export default component.exports